import type * as KnowledegFileType from '@/types/knowledge/file'
import { KnowlegeLibSortType } from '@/types/knowledge/common'
import { get, post } from '@/utils/request'

/**
 * 列表查看 带概要，支持指定排序，分页
 */
export function getKnowledegFileList(data: KnowledegFileType.KnowlegeFileParams) {
  const defaultParams = {
    page: 1,
    pageSize: 10,
    sort: 'uploadTime',
    order: 'desc',
    keyword: '',
    ...data,
  }
  return post<KnowledegFileType.ListFileModel>({
    url: '/assistant/lib/file/page',
    data: defaultParams,
  })
}

/**
 * 查看待分类列表
 */
export function getUnClassifyFileList(data: KnowledegFileType.KnowlegeFileParams) {
  const defaultParams = {
    page: 1,
    pageSize: 10,
    sort: KnowlegeLibSortType.UpdateTime,
    ...data,
  }
  return post<KnowledegFileType.ListFileClassifyModel>({
    url: '/assistant/lib/file/pageNoClassify',
    data: defaultParams,
  })
}

/**
 * 查看已分类列表
 */
export function getClassifyFilelist(data: KnowledegFileType.KnowlegeFileParams) {
  const defaultParams = {
    page: 1,
    pageSize: 10,
    sort: KnowlegeLibSortType.UpdateTime,
    ...data,
  }
  return post<KnowledegFileType.ListFileClassifyModel>({
    url: '/assistant/lib/file/pageClassify',
    data: defaultParams,
  })
}

/**
 * 保存上传文件列表(支持批量)
 */
export function saveFileList(data: KnowledegFileType.SaveFilesParams) {
  return post<number[]>({
    url: '/assistant/lib/file/saveFiles',
    data,
  })
}

/**
 * 更新文件 重命名 / 修改备注
 */
export function updateFile(data: KnowledegFileType.UpdateFileParams) {
  return post<{ model: boolean }>({
    url: '/assistant/lib/file/update',
    data,
  })
}

/**
 * 删除文件 支持批量操作
 */
export function deleteFiles(data: { fileIds: number[]; enterpriseId: number; knowledgeBaseId: number }) {
  return post<{ model: boolean }>({
    url: '/assistant/lib/file/remove',
    data,
  })
}

/**
 * 移动文件 支持批量操作
 */
export function moveFiles(data: KnowledegFileType.MoveFilesParams) {
  return post<{ model: boolean }>({
    url: '/assistant/lib/file/move',
    data,
  })
}

/**
 * 复制文件 支持批量操作
 */
export function copyFilesTo(data: KnowledegFileType.CopyFilesParams) {
  return post<{ model: boolean }>({
    url: '/assistant/lib/file/copyTo',
    data,
  })
}

/**
 * 共享文件到共享库 支持批量操作
 */

export function shareFilesTo(data: KnowledegFileType.ShareFilesParams) {
  return post<{ points: number }>({
    url: '/assistant/lib/file/share',
    data,
  })
}

/**
 * 查看文件详情 全文摘要、章节摘要、推荐问题
 */
export function getFileDetail(data: KnowledegFileType.FileDetailParams) {
  return post<KnowledegFileType.FileDetailModel>({
    url: '/assistant/lib/file/getDetail',
    data,
  })
}

/**
 * 查看原文  一页一页的方式返回原文 OCR识别
 */
export function getFileContent(data: KnowledegFileType.FileDetailParams) {
  return post<KnowledegFileType.FileContentModel>({
    url: '/assistant/lib/file/getWhole',
    data,
  })
}

/**
 * 重复度查看 单知识库下内容相似度评估
 */

export function getFileSimilar(data: KnowledegFileType.FileDetailParams) {
  return post<KnowledegFileType.FileSimilarItem[]>({
    url: '/assistant/lib/file/getSimilar',
    data,
  })
}

/**
 * 摘要跳转 跳转到具体某一页
 */

export function getFileDigest(data: {
  fileId: number
  pageIndex: number
}) {
  return post<KnowledegFileType.FileDigestMdel>({
    url: '/assistant/lib/file/getDigest',
    data,
  })
}

/**
 * 收藏/取消收藏文件
 */
export function setCollectFile(data: {
  enterpriseId: number
  fileId: number
  knowledgeBaseId: number
  collectFlag?: number // 1 收藏 0 取消收藏
}) {
  return post<boolean>({
    url: '/assistant/lib/file/collectFile',
    data,
  })
}

export function getCollectFileList(data: {
  enterpriseId: number
  page?: number
  pageSize?: number
  sort?: KnowlegeLibSortType
}) {
  const defaultParams = {
    page: 1,
    pageSize: 10,
    ...data,
  }
  return post<{ records: any[] }>({
    url: '/assistant/lib/file/myCollectPage',
    data: defaultParams,
  })
}

/**
 * 剩余可上传文件数量
 * @returns limit 剩余大小：文件为个数，大小单位为kb;type 剩余类型：0：文件个数 1：文件大小;allLimit 总限制大小：文件为个数，大小单位为b
 */
export function getFileRemain(knowledgeBaseId: string | number) {
  return get<{ allLimit: number; limit: number; type: number }>({
    url: `/assistant/lib/file/filesRemain?knowledgeBaseId=${knowledgeBaseId}`,
  })
}

/**
 * 文件预上传
 */
export function getFilePreUpload(data: { knowledgeBaseId: number; fileNum: number; fileSize: number }) {
  return get<{ allLimit: number; exceedNum: number; flowNo: string; limit: number; type: number }>({
    url: '/assistant/lib/file/preUpload',
    data,
  })
}
